import { axiosClient, axiosClientAuth } from './axiosClient'

export const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

export { axiosClient, axiosClientAuth }